module.exports = __webpack_public_path__ + "img/app.4390b4ed.png";